import { Box, styled } from "@mui/material";
import modelApplications from "../../constants/modelApplications.json";

const getModelApplicationColor = (type) => {
  const match = modelApplications.find(
    (application) => application.value === type,
  );
  return match?.color || "#7180a0";
};

const ModelApplicationBox = styled(Box)(({ type }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "4px 12px",
  borderRadius: "12px",
  color: "white",
  backgroundColor: getModelApplicationColor(type),
  fontWeight: "bold",
  textAlign: "center",
  minWidth: 0,
  whiteSpace: "nowrap",
}));

export default ModelApplicationBox;
